import { stripLeadingSpeakerLabel } from './postBody';

/**
 * Search markup for one post: the highlighted or snippeted HTML the search
 * returned for each field, absent where it returned none.
 */
export type SearchMarkup = {
  title?: string;
  body?: string;
};

/**
 * What a list card draws. An empty highlight falls through to the plain text,
 * and the body drops the "Question:" label the post body opens with, and a
 * leading speaker label.
 */
export function summaryDisplayText(
  post: { title: string; body: string },
  highlight: SearchMarkup,
  snippet: SearchMarkup
) {
  return {
    displayTitle: highlight.title || post.title,
    displayExcerpt: stripLeadingSpeakerLabel(
      snippet.body || highlight.body || post.body.replace(/Question:\n/g, '')
    ),
  };
}

/**
 * What the post screen draws.
 *
 * Known divergence from the list, kept on purpose: here an empty highlight is
 * drawn as empty rather than falling through to the plain text, and the body
 * keeps its "Question:" label. Unifying the two is a visible change, so it
 * belongs in a product decision, not in this refactor.
 */
export function postDisplayText(post: { title: string; body: string }, highlight: SearchMarkup) {
  return {
    displayTitle: highlight.title ?? post.title,
    displayBody: highlight.body ?? post.body,
  };
}
